import React from 'react';
import './coupon-exist-content.css';
import CouponCodeItem from '../coupon-code-Item/coupon-code-item';
import {
  Carousel,
  CarouselArrow,
  CarouselContent,
  CarouselItem,
} from '@wwe-portal/ui/components/carousel';
import { Each } from '@wwe-portal/ui/components/utils';

export const CouponExistContent = ({ offerItems }) => {
  return (
    <div className="couponCodePopupExist__wrapperItems d-flex justify-content-center align-items-center">
      <div className="couponCodePopupExist__items justify-content-center align-items-center flex">
        {offerItems.length > 1 ? (
          <div className="w-[270px]">
            <Carousel
              className="overflow-hidden pr-3"
              opts={{
                startIndex: 0,
                loop: true,
                containScroll: 'trimSnaps',
              }}
            >
              <CarouselContent className="ml-0">
                <Each
                  data={offerItems}
                  render={(item, i) => (
                    <CarouselItem data-carousel-item>
                      <div
                        key={i}
                        className="couponCodePopupExist__wrapperItem justify-content-center align-items-center flex py-3"
                      >
                        <CouponCodeItem data={item} />
                      </div>
                    </CarouselItem>
                  )}
                />
              </CarouselContent>
              <CarouselArrow />
            </Carousel>
          </div>
        ) : (
          <div className="couponCodePopupExist__wrapperItem d-flex justify-content-center align-items-center">
            <CouponCodeItem data={offerItems[0]} />
          </div>
        )}
      </div>
    </div>
  );
};
